export default __webpack_public_path__ + "static/media/guest-ranger-logo-mobile-white.a18066a8.svg";